<template>
  <div data-test="forget-shop__page">Déconnexion magasin...</div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch('shopAuth/logout').then(() => {
      setTimeout(() => {
        this.$router.push({ name: 'ShopSignIn' });
      }, 2000);
    });
  },
};
</script>
<style lang="scss" scoped>
</style>
